import { HStack, List, ListItem, ListProps, chakra } from "@chakra-ui/react";
import { Key, ReactElement, useMemo } from "react";
import { ListOption } from "../core/types";

interface ComboboxProps<T extends Key> extends Omit<ListProps, "onChange"> {
  value: Array<T>;
  options: ListOption<T>[];
  onChange?: (value: Array<T>) => void;
}

export default function Combobox<T extends Key>(
  props: ComboboxProps<T>
): ReactElement {
  const { value, options, onChange, ...rest } = props;

  const selectedSet = useMemo(() => new Set(value), [value]);

  return (
    <List w="100%" display="flex" flexDirection="column" role="menu" {...rest}>
      {options.map((item) => (
        <ListItem
          key={item.value}
          className="filter-option"
          w="100%"
          h="100%"
          px="4"
          py="2"
          cursor="pointer"
          role="menuitemcheckbox"
          _hover={{ bg: "gray.100" }}
          onClick={() =>
            onChange?.(
              selectedSet.has(item.value)
                ? value.filter((other) => other !== item.value)
                : [...value, item.value]
            )
          }
        >
          <HStack spacing="3" w="100%" h="100%">
            <chakra.input
              type="checkbox"
              checked={selectedSet.has(item.value)}
              readOnly={true}
              __css={{ accentColor: "var(--chakra-colors-gray-600)" }}
            />
            <chakra.span>{item.label}</chakra.span>
          </HStack>
        </ListItem>
      ))}
    </List>
  );
}
